import dayjs from 'dayjs'

//todo, use this in employment summary?

export function calculateAverageJobDuration(jobs) {
  if (jobs.length === 0) {
    return '0 months'
  }

  let sum = 0
  jobs.forEach((job) => {
    const startDate = dayjs(job?.startDate)
    const endDate = job?.endDate ? dayjs(job.endDate) : dayjs()
    const months = endDate.diff(startDate, 'month', true)

    sum += months
  })

  const averageMonths = sum / jobs.length
  if (averageMonths >= 12) {
    return (averageMonths / 12).toFixed(1) + ' years'
  } else if (averageMonths < 1) {
    return '< 1 month'
  } else if (averageMonths === 1) {
    return '1 month'
  } else {
    return Math.round(averageMonths) + ' months'
  }
}
